import { ApiUtility } from "./ApiUtility";
import { notifyFavoriteMutation } from "../utils/favoriteFeedback";

class ArticlesService {
  getNavigationDetails(articleId: string): any {
    throw new Error("Method not implemented.");
  }
  route = "/posts";
  articleRoute = "/api/articles?lang=";
  articledetsil = "/api/articles/";
  categoryRoute = "/api/settings/filters?lang=";
  faviroute = "/api/articles/";

  GetAuthorDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/Articles/Authors/${identifier}?lang=` + localStorage.getItem("lan")
    );
  }

  /** Resolve article category by Mongo id or slug (same identifier rule as books). */
  GetCategoryDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/Articles/Categories/${identifier}?lang=` + localStorage.getItem("lan")
    );
  }

  /** Language metadata — shared /api/languages endpoint used by books. */
  GetLanguageDataById(id: string) {
    return ApiUtility.get(
      "/api/languages/" + id + "?lang=" + localStorage.getItem("lan")
    );
  }

  getFilters = (productFor: string, authorId?: string) => {
    let url =
      this.categoryRoute +
      localStorage.getItem("lan") +
      "&productFor=" +
      productFor;
    if (authorId) {
      url += "&authorId=" + authorId;
    }
    return ApiUtility.get(url);
  };

  getArticles = (
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean
  ) => {
    return ApiUtility.get(
      this.articleRoute +
      localStorage.getItem("lan") +
      "&start=" +
      start +
      "&length=" +
      length +
      "&categoryId=" +
      categoryId +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&authorId=" +
      authorId +
      "&search=" +
      search +
      "&sort=" +
      sort +
      "&bookLangauge=" +
      langId +
      "&isSpecial=" +
      isSpecial
    );
  };

  // article detail

  getArticlesDetail = (id: string) => {
    return ApiUtility.get(
      this.articledetsil +
      id +
      "?lang=" +
      localStorage.getItem("lan")
    );
  };


  getArticleDetail = (id: string) => {
    const lang = localStorage.getItem("lan") || "hindi";
    return ApiUtility.get(`${this.articledetsil}${id}/SEO?lang=${lang}`);
  };


  addArticlesFavourite = (ArticleId: string) => {
    return notifyFavoriteMutation(ApiUtility.post(this.faviroute + ArticleId + "/favourite", {}), "article", "added");
  };

  removeArticlesFaviourite = (ArticleId: string) => {
    return notifyFavoriteMutation(ApiUtility.delete(this.faviroute + ArticleId + "/favourite"), "article", "removed");
  };

  getarticlesCategory = (lang?: string) => {
    return ApiUtility.get(
      "/api/Articles/Categories?lang=" + lang
    );
  }

  getArticleById = (id: string, userId?: string, lang?: string) => {
    return ApiUtility.get(
      this.articledetsil + id + "?UserId=" + userId + "&lang=" + lang
    );
  }
}
export default new ArticlesService();
